import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormGroupDirective, FormControl, NgForm } from '@angular/forms';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: 'app-expanding-search',
  templateUrl: './expanding-search.component.html',
  styleUrls: ['./expanding-search.component.scss']
})
export class ExpandingSearchComponent implements OnInit {
  model: string;
  expanded: Boolean = false;
  modelChanged: Subject<string> = new Subject<string>();
  @Input() label: string;
  @Input() placeholder: string;
  @Input() searchText: string;
  @Input() required: boolean;
  @Input() requiredErrorMessage: string;
  @Input() regExp;
  @Input() regExpErrorMessage: string;
  @Input() debounceTimeInMs: number;
  @Input() noSearch: boolean;
  @Input() pathString: string;
  @Input() width: string;
  @Input() landDirectlyOnInputField?: Boolean = false;
  @Output() valueChangeCallback = new EventEmitter<any>();
  @ViewChild('search') searchField: ElementRef;
  public matcher = new MyErrorStateMatcher();
  constructor() { }

  ngOnInit() {
    this.model = this.searchText;
    if (this.model) {
      this.expanded = true;
    }
    this.modelChanged.pipe(
      debounceTime(this.debounceTimeInMs),
      distinctUntilChanged())
      .subscribe((model) => {
        // this.model = model;
        this.valueChangeCallback.emit(this.model);
      });
  }

  valueChange(text: string, search) {
    this.model = text;
    if (typeof search === 'boolean' || search && search.validity && search.validity.valid) {
      this.modelChanged.next(text);
    }
  }

  focus() {
    if (this.searchField) {
      this.searchField.nativeElement.focus();
      return;
    }
    setTimeout(() => {
      this.searchField && this.searchField.nativeElement.focus();
    });
  }
  
  clearInputField(): void {
    this.model = '';
    this.expanded = false;
    this.valueChange("",true);
  }
}
